import React from 'react';

import ruslan from '../audio/ruslan.mp3';

import InternalPage from '../components/InternalPage';
import Peek from '../components/Peek';
import Blur from '../components/Blur';

import internalPageStyle from '../components/InternalPage/layout.module.css';

import RuslanHidden from '../images/Ruslan-hidden.jpg';
import RuslanOver from '../images/Ruslan-over.png';
import RuslanBlur from '../images/Ruslan-blur.jpg';
import RuslanBlurOver from '../images/Ruslan-blur-over.jpg';

const RuslanPage = () => (
  <InternalPage
    name="Руслан"
    bio="Свободный художник, 29 лет"
    audio={ruslan}
    audioDuration={201}
  >
    <div className={internalPageStyle.titleContainer}>
      <h2
        className={`${internalPageStyle.title} ${
          internalPageStyle.title_middle
        }`}
      >
        ГЕТЕРОПОРНО Я&nbsp;ВООБЩЕ НЕ&nbsp;СМОТРЮ
      </h2>
      <div className={internalPageStyle.topImage}>
        <Peek
          hiddenImage={RuslanHidden}
          overImage={RuslanOver}

          limitX={70}
          limitY={50}

          scale={1.2}

          depthXOver={0}
          depthYOver={0}
        />
      </div>
    </div>

    <div className={internalPageStyle.textContainer}>
      <p className={internalPageStyle.text}>
        В&nbsp;наше время сложно уклониться от&nbsp;просмотра порно, по-моему,
        оно изо всех щелей идёт. Не&nbsp;помню, кто писал, но&nbsp;первое слово,
        которое вбивает новый пользователь в&nbsp;поисковую строку, это
        &laquo;f*ck&raquo;, и&nbsp;дай бог, если это &laquo;F*ck, how beautiful
        Shakespear&rsquo;s poems are&raquo;.
      </p>

      <p className={internalPageStyle.text}>
        Свои просмотры я&nbsp;стараюсь ограничивать, потому что понимаю, что
        в&nbsp;порно всё немного не&nbsp;так, как в&nbsp;жизни. Смотрю как
        средство эмоциональной разрядки, как снотворное. Это немного напоминает
        поход в&nbsp;картинную галерею: большинство мужчин-моделей
        в&nbsp;великолепной форме и&nbsp;похожи на&nbsp;греческие статуи. Иногда
        увлекают сюжеты, хотя чаще всего они совсем простые. Иногда&nbsp;&mdash;
        какие-то технические вещи. От&nbsp;партнёра всё&nbsp;же узнаешь гораздо
        больше. Но&nbsp;для неофитов фильмы действительно могут быть
        своеобразным учебником.
      </p>

      <p className={internalPageStyle.quote}>
        В&nbsp;сюжетах меня привлекает присутствие третьего
        партнёра&nbsp;&mdash; это, пожалуй, то, что хотелось&nbsp;бы повторить.
      </p>

      <p className={internalPageStyle.text}>
        Мне нравятся нежные, романтичные истории, часто даже скорее эротика,
        а&nbsp;не&nbsp;порно. Насилие меня не&nbsp;привлекает: я&nbsp;понимаю,
        зачем люди такое смотрят, но&nbsp;сам равнодушен. Гетеропорно
        я&nbsp;вообще не&nbsp;смотрю, не&nbsp;могу отделаться от&nbsp;ощущения,
        что женщин там просто эксплуатируют. А&nbsp;в&nbsp;мужском таких мыслей
        даже не&nbsp;возникает.
      </p>

      <p className={internalPageStyle.text}>
        Я&nbsp;не&nbsp;чувствую себя зависимым от&nbsp;порно. Но&nbsp;знаю, что
        есть люди, которые так привыкли доверять собственным конечностям, что
        закрываются от&nbsp;реальных отношений, где чувствуют себя слишком
        уязвимыми и&nbsp;беззащитными. И&nbsp;по&nbsp;тем&nbsp;же причинам
        пользуются проституцией, желая оставаться в&nbsp;эмоциональной
        безопасности.
      </p>

      <div className={internalPageStyle.middleImage}>
        <Blur image={RuslanBlur} imageBlur={RuslanBlurOver} />
      </div>

      <p className={internalPageStyle.text}>
        В&nbsp;порноиндустрии всё преувеличено, реальный партнёр может быть
        не&nbsp;таким привлекательным, не&nbsp;таким техничным.
        Ну&nbsp;и&nbsp;порноактёры сидят на&nbsp;стимуляторах&nbsp;&mdash;
        не&nbsp;может нормальный физический акт длиться столько, сколько
        в&nbsp;кино. Как шутят стендаперы, &laquo;думал, что смогу заниматься
        сексом четыре часа, но&nbsp;на&nbsp;пятой минуте теория
        опроверглась&raquo;.
      </p>

      <p className={internalPageStyle.text}>
        Если ты&nbsp;застенчивый подросток, порно может дать много информации,
        но, если ограничиться только этим, потом будет очень сложно
        переключиться на&nbsp;живых людей. Сейчас так много историй, как люди
        очеловечивают своих секс-кукол, убегая от&nbsp;настоящих отношений.
        Думаю, рефлексирующим натурам такое не&nbsp;грозит, потому что они
        склонны докапываться до&nbsp;дна и&nbsp;смотрят порно достаточно
        осознанно.
      </p>
    </div>
  </InternalPage>
);

export default RuslanPage;
